























import { Component, Mixins, Prop } from 'vue-property-decorator';
import { resolveModule } from '@/store';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { Event } from '@/modules/backend/Entities/Event';
import Mixin from '@/mixins/base';
import { EventsModule } from '@/store/dashboard/events/EventsModule';
import { Counter } from '@/modules/backend/Entities/Counter';

@Component({
  mixins: [Mixin],
  components: {
    'data-table-wrapper': DataTableWrapper
  }
})
export default class CounterLogs extends Mixins(Mixin) {
  @Prop({
    required: true,
    type: Object,
    validator: a => a instanceof Counter,
  })
  private readonly counter!: Counter;

  private readonly events: EventsModule = resolveModule(EventsModule);
  private interval?: NodeJS.Timeout;

  private get items(): Event[] {
    return this.events.events.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
  }

  private async load(): Promise<void> {
    await this.events.fetch({
      companyIds: [this.counter.getId()],
      offset: 0,
      limit: 10,
    });
  }

  public async mounted(): Promise<void> {
    await this.load();
    const FETCH_INTERVAL = 60000;
    this.interval = setInterval(() => this.load(), FETCH_INTERVAL);
  }

  public async beforeDestroy(): Promise<void> {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
